import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IUpdateShift {
  id: string[];
  status: boolean;
}

const updateShift = (payload: IUpdateShift) => {
  const newEndpoint = endpoints.shifts.acceptDecline;
  return http().post(newEndpoint, payload);
};

export function useUpdateShift() {
  return useMutation({ mutationFn: updateShift });
}
